export const partIsClickable = (currentPart = 1, partStarted = {}) => (
  part = 1
) => {
  const isNotCurrentPart = currentPart !== part;
  const partIsStarted = partStarted[part];
  const partBeforeIsStarted = partStarted[part - 1];

  return isNotCurrentPart && (partIsStarted || partBeforeIsStarted);
};
